import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Box, CircularProgress, Paper, Typography, Button, Chip } from '@mui/material';
import { Edit as EditIcon, ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import SpreadsheetBuilder from './SpreadsheetBuilder';
import axios from 'axios';

const SpreadsheetView = () => {
  const { formId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tableData, setTableData] = useState(null);
  
  const appToken = useSelector((state) => state.appToken.apptoken);
  const userData = useSelector((state) => state.loginData.loginData);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        console.log('SpreadsheetView: API çağrısı başlıyor, formId:', formId);
        
        const response = await axios.get(`https://app.hhoms.com/api/form/Libraries/${formId}`, {
          headers: {
            ApplicationToken: appToken,
            User: userData.id,
          },
        });

        console.log('SpreadsheetView: API response alındı, boyut:', JSON.stringify(response.data).length, 'karakter');

        // API response yapısını kontrol et
        console.log('API Response yapısı:', response.data);
        
        let tableLibrary;
        
        // API response'ı kontrol et - formLibraries object mi yoksa array mi?
        if (response.data && response.data.formLibraries) {
          if (Array.isArray(response.data.formLibraries)) {
            console.log('FormLibraries array bulundu, uzunluk:', response.data.formLibraries.length);
            // Array formatı - ilgili form'u bul
            tableLibrary = response.data.formLibraries.find(lib => lib.formId === formId || lib.id.toString() === formId);
            
            if (!tableLibrary && response.data.formLibraries.length > 0) {
              // Eğer formId ile bulamazsa, ilk elemanı al
              tableLibrary = response.data.formLibraries[0];
              console.log('FormId ile bulunamadı, ilk element alındı:', tableLibrary);
            }
          } else {
            // Object formatı - direkt kullan
            console.log('FormLibraries object bulundu');
            tableLibrary = response.data.formLibraries;
          }
        } else if (response.data && response.data.id) {
          // Direkt form object'i dönmüş
          tableLibrary = response.data;
          console.log('Direkt form object alındı');
        } else {
          console.error('Beklenmeyen API response yapısı:', response.data);
        }
        
        if (!tableLibrary) {
          setError('Tablo bulunamadı');
          return;
        }
        
        console.log('Seçilen table library:', tableLibrary);
        console.log('FormContent tipi:', typeof tableLibrary.formContent);
        console.log('FormContent preview:', tableLibrary.formContent?.substring(0, 100) + '...');
        
        if (!tableLibrary || !tableLibrary.formContent) {
          setError('Tablo bulunamadı veya içerik boş');
          return;
        }

        console.log('SpreadsheetView: formContent mevcut, tablo yükleniyor...');
        
        // Store'dan mevcut veriyi kullan - parse işlemleri kaldırıldı
        setTableData({
          title: tableLibrary.title,
          description: tableLibrary.description || '',
          formContent: tableLibrary.formContent // Direkt formContent kullan
        });
        
        console.log('SpreadsheetView: Store güncellendi');
        
      } catch (err) {
        console.error('SpreadsheetView: Hata:', err);
        if (err.message?.includes('404')) {
          setError('Tablo bulunamadı');
        } else if (err.message?.includes('401') || err.message?.includes('403')) {
          setError('Bu tabloya erişim yetkiniz yok');
        } else {
          setError('Tablo yüklenirken bir hata oluştu');
        }
      } finally {
        setLoading(false);
      }
    };

    if (formId && appToken && userData.id) {
      fetchData();
    }
  }, [formId, appToken, userData.id]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', py: 8 }}>
        <CircularProgress size={40} />
        <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary' }}>
          Tablo yükleniyor...
        </Typography>
        <Typography variant="caption" sx={{ mt: 1, color: 'text.disabled' }}>
          Büyük tablolar biraz zaman alabilir
        </Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ textAlign: 'center', py: 8 }}>
        <Typography color="error">{error}</Typography>
        <Button onClick={() => navigate('/tables')} sx={{ mt: 2 }}>
          Tablolara Dön
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2 }}>
      {/* Üst Başlık ve Aksiyonlar */}
      <Paper elevation={1} sx={{ p: 2, mb: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Button
              startIcon={<ArrowBackIcon />}
              onClick={() => navigate('/tables')}
              variant="outlined"
              size="small"
            >
              Tablolara Dön
            </Button>
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              {tableData?.title || 'Tablo Görüntüleme'}
            </Typography>
            <Chip label="Sadece Görüntüleme" color="info" size="small" />
          </Box>
          
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
              variant="contained"
              startIcon={<EditIcon />}
              onClick={() => navigate(`/spreadsheet-edit/${formId}`)}
            >
              Düzenle
            </Button>
          </Box>
        </Box>
        
        {tableData?.description && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            {tableData.description}
          </Typography>
        )}
      </Paper>

      {/* Spreadsheet - Readonly Mode */}
      <Box sx={{ p: 0 }}>
        <SpreadsheetBuilder 
          readOnly={true} 
          initialData={tableData}
        />
      </Box>
    </Box>
  );
};

export default SpreadsheetView;



